<template>
    <div class="c-panel c-panel--border c-panel--expand margin-b-24">
        <h3 class="margin-b-16">Activiteit</h3>
        <p v-if="Object.keys(formatted).length == 0" class="color-dark-gray no-margin">Geen activiteit gevonden</p>
        <div class="c-timeline" v-if="Object.keys(formatted).length">

            <div class="c-timeline__date" v-for="date in Object.keys(formatted).slice(0, max)">
                <div class="c-timeline__day">{{date | prettydate }}</div>
                <div class="c-timeline__item" v-for="activity in formatted[date]">
                    <div class="c-timeline__time">{{activity.created_at | time}}</div>
                    <div class="c-timeline__title">{{activity.activiteit}}</div>
                </div>
            </div>

        </div>

         <div class="c-timeline__more" v-if="Object.keys(formatted).length > max">
            <a href="#" @click.prevent="max = max + 3">Meer weergeven</a>
        </div>

        <div class="c-timeline__more" v-else-if="Object.keys(formatted).length > 3">
           <a href="#" @click.prevent="max = max - 3">Minder weergeven</a>
       </div>
    </div>
</template>

<script>
export default {
    props: {
        activities: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            max: 3,
        }
    },
    computed: {
        formatted() {
            let output = {};

            this.activities.forEach( (a) => {

                let date = this.$options.filters['datestring'](a.created_at);

                if ( output[date] == undefined ) {
                    output[date] = [];
                }

                output[date].push(a);
            });

            return Object.keys(output).sort().reverse().reduce(
                  (obj, key) => {
                    obj[key] = output[key];
                    return obj;
                  },{}
            );
        }
    }
}
</script>
